export default "__VITE_ASSET__BRLRcqIS__"